const productListEquipments = document.querySelector('.js-equipment-list');

if (productListEquipments) {
  (() => {
    const items = Array.from(productListEquipments.getElementsByTagName('li'));
    if (items.length <= 15) {
      productListEquipments.classList.add('is-open');
      return;
    }

    let totalHeight = 0;
    let partialHeight = 0;
    for (let index = 0; index < items.length; index++) {
      const item = items[index];
      totalHeight += item.clientHeight;
      if (index > 0) totalHeight += 14;
      if (index <= 15) partialHeight = totalHeight;
    }

    productListEquipments.style.height = `${partialHeight}px`;

    const productListExpand = document.querySelector('.js-equipment-expand');
    const labelMore = productListExpand.dataset.labelMore;
    const labelLess = productListExpand.dataset.labelLess;

    if (productListExpand) {
      productListExpand.addEventListener('click', () => {
        if (productListEquipments.classList.contains('is-open')) {
          productListEquipments.style.height = `${partialHeight}px`;
          productListEquipments.classList.remove('is-open');
          productListExpand.textContent = labelMore;
        } else {
          productListEquipments.style.height = '';
          productListEquipments.classList.add('is-open');
          productListExpand.textContent = labelLess;
        }
        productListEquipments.scrollIntoView(true);
      });
    }
  })()
}
